import { useContext, useEffect, useRef, useState } from 'react'
import PageWrapper from '../../layout/PageWrapper/PageWrapper'
import Page from '../../layout/Page/Page'
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardTitle } from '../bootstrap/Card'
import Input from '../bootstrap/forms/Input'
import Button from '../bootstrap/Button'
import AuthContext from '../../contexts/authContext'
import { toasts } from '../../services/toaste.service'
import { getSubDispatchListByDate, updatePackingDetails } from '../../services/productService'
import FormGroup from '../bootstrap/forms/FormGroup'
import Collapse from '../bootstrap/Collapse'
import { convertDateToEpoch, getCompanyDetails, getCurrentDateAndTime, onlyAllowNumber } from '../../services/common.service'
import OpenCardComponent from '../../common/components/OpenCardComponent'
import useSortableData from '../../hooks/useSortableData'
import { dataPagination } from '../PaginationButtons'
import { useReactToPrint } from 'react-to-print';
import SearchableSelect from '../../common/components/SearchableSelect'
import { getLicenseKey } from '../../services/application.settings'
import { showLoader } from '../../services/loader.services'
import dayjs from 'dayjs'

const AvrDispatchList = () => {

    useEffect(() => {
        getCompanyList();
    }, [])

    // For Alert
    const [alertStatus, setAlertStatus] = useState<any>({ message: "", type: "" });
    const [isOpen, setIsOpen] = useState(false);

    const { userAccountId, userTypeId } = useContext(AuthContext);
    const [productList, setProductList] = useState<any>([])
    const [noDataMsg, setNoDataMsg] = useState('');
    const [date, setDate] = useState<any>(getCurrentDateAndTime('date'));

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const { items, requestSort, getClassNamesFor } = useSortableData(productList);
    const onCurrentPageData = dataPagination(items, currentPage, perPage);

    const [dataStatus, setDataStatus] = useState(false)
    const [isOpenListCard, setIsOpenListCard] = useState(true);
    const [isLoader, setIsLoader] = useState(false);

    function viewProductList() {
        setDataStatus(false)
        let dateInMilliSeconds = convertDateToEpoch(date);
        if (companyDetailsId?.value != undefined) {
            getScannedProductList(dateInMilliSeconds, companyDetailsId?.value)
        }

    }

    function getScannedProductList(date: any, companyDetailsId: any) {
        setDataStatus(false)
        setIsLoader(true)
        getSubDispatchListByDate(date, companyDetailsId,
            (response) => {
                if (response.data.success) {
                    let rawData = response.data.data.subDispatchListByDate;
                    if (rawData != undefined) {
                        let data: any[] = [];
                        // Flatten lotDetails into top-level items for the UI
                        rawData.forEach((company: any) => {
                            company.lotDetails.forEach((lot: any) => {
                                data.push({
                                    ...company,
                                    ...lot,
                                    productList: lot.dispatchItems,
                                    truckNo: company.vehicleNo,
                                    updatedDateForView: dayjs(company.dispatchDate).format('DD/MM/YYYY'),
                                    totalGrossWeight: lot.dispatchItems.reduce((s: any, r: any) => s + Number(r.grossWeight || 0), 0),
                                    totalTareWeight: lot.dispatchItems.reduce((s: any, r: any) => s + Number(r.tareWeight || 0), 0),
                                    totalNetWeight: lot.dispatchItems.reduce((s: any, r: any) => s + Number(r.netWeight || 0), 0)
                                });
                            });
                        });

                        setDataStatus(true)
                        setIsOpenListCard(false);
                        setIsLoader(false)

                        for (let i = 0; i < data.length; i++) {

                            if (data[i].packingDetails != null) {
                                data[i]['packingList'] = data[i].packingDetails;
                                const totalPackingCount = data[i].packingDetails.reduce((s: any, r: any) => s + Number(r.packingCount || 0), 0);
                                data[i]['totalPackingCount'] = (totalPackingCount / data[i].packingDetails?.length).toFixed(2)
                            } else {
                                data[i]['packingList'] = [
                                    { packingDetailsId: 0, dispatchProductDetailsId: data[i].dispatchProductDetailsId, packingDescription: '', packingDate: '', packingCount: '', displayOrder: 1 }
                                ]
                                data[i]['totalPackingCount'] = 0;
                            }

                            let productList = data[i].productList;

                            for (let j = 0; j < productList.length; j++) {
                                productList[j].sno = j + 1;
                            }

                            const rowsPerTable = Math.ceil(data[i]?.productList.length / 2);

                            const totalRequired = rowsPerTable * 2;

                            // Step 1: pad array to ensure even distribution in columns
                            let paddedRows: any = [...data[i]?.productList];

                            while (paddedRows.length < totalRequired) {
                                paddedRows.push({
                                    sno: '',
                                    bagNo: "",
                                    exciseNo: "",
                                    grossWeight: "",
                                    tareWeight: "",
                                    netWeight: ""
                                });
                            }

                            const left = paddedRows.slice(0, rowsPerTable);
                            const right = paddedRows.slice(rowsPerTable);

                            data[i].leftRows = left;
                            data[i].rightRows = right;

                            const totals = (rows: any) =>
                                rows.reduce(
                                    (a: any, r: any) => ({
                                        gross: a.gross + Number(r.grossWeight || 0),
                                        tare: a.tare + Number(r.tareWeight || 0),
                                        net: a.net + Number(r.netWeight || 0),
                                    }),
                                    { gross: 0, tare: 0, net: 0 }
                                );

                            data[i].leftTotals = totals(left);
                            data[i].rightTotals = totals(right);
                        }
                        setProductList(data)

                        let packingData = data.flatMap((item: any) => item.packingList)
                        let packingList = packingData.filter((item: any) => item.packingDescription !== '' || item.packingDate !== '' || item.packingCount !== '')
                        setPackingList(packingList);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setNoDataMsg(response.data.message)
                    setDataStatus(true)
                    setIsOpenListCard(false);
                    setIsLoader(false)
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                    setIsLoader(false)
                }
            }, error => {
                toasts(error, "Error")
                setIsLoader(false)
            }
        )
    }

    const [isPrintShow, setIsPrintShow] = useState<any>(true);

    const componentRef = useRef(null);

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
    });

    const [refreshData, setRefreshData] = useState<any>([]);

    const [addExamHallAllocation, setAddExamHallAllocation] = useState<any>([
        { packingDescription: '', packingDate: '', packingCount: '', displayOrder: 1 }
    ])

    function add(data: any) {

        const newData: any = []

        productList.forEach((item: any) => {
            if (item['dispatchProductDetailsId'] == data['dispatchProductDetailsId']) {
                item['packingList'] = [...item['packingList'], { dispatchProductDetailsId: item['dispatchProductDetailsId'], packingDescription: '', packingDate: '', packingCount: '', displayOrder: item['packingList'].length + 1 }]
            }
            newData.push(item)
        });

        setProductList(newData);
        setRefreshData(newData)

    }

    const [packingList, setPackingList] = useState<any>([])

    function onValueChange(productData: any, value1: any, date1: any, count1: any, index: any) {

        const newData: any = []

        productList.forEach((item: any) => {

            if (item['dispatchProductDetailsId'] == productData['dispatchProductDetailsId']) {

                const list = [...item['packingList']];
                list[index]["packingDetailsId"] = productData['packingDetailsId'] != undefined ? productData['packingDetailsId'] : 0;
                list[index]["dispatchProductDetailsId"] = productData['dispatchProductDetailsId'];
                list[index]["packingDescription"] = value1;
                list[index]["packingDate"] = date1;
                list[index]["packingCount"] = count1;
                list[index]["displayOrder"] = index + 1;

                const validPacking = list.filter((p: any) => p.packingDescription && p.packingDate && p.packingCount);
                const totalPackingCount = validPacking.reduce((s: any, r: any) => s + Number(r.packingCount || 0), 0);

                item['packingList'] = list
                item['totalPackingCount'] = (validPacking.length > 0 ? (totalPackingCount / validPacking.length) : 0).toFixed(2)

                setAddExamHallAllocation(list)
                setRefreshData(list)
            }
            newData.push(item)
        });

        let packingData = newData.flatMap((item: any) => item.packingList)
        let packingList = packingData.filter((item: any) => item.packingDescription !== '' || item.packingDate !== '' || item.packingCount !== '')
        setPackingList(packingList)
    }

    function selectPrint() {
        handlePrint();
        setIsPrintShow(true)
    }

    const [companyDetailsData, setCompanyDetailsData] = useState<any>([]);
    const [companyDetailsId, setCompanyDetailsId] = useState<any>('');

    function getCompanyList() {
        getCompanyDetails(0,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.companyDetails;
                    if (data != undefined) {
                        setCompanyDetailsData(data)
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setCompanyDetailsData([])
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function setPackingDetails() {
        return ({
            licenseKey: getLicenseKey,
            userAccountId: userAccountId,
            packingDetails: packingList
        })
    }

    function updatePackingDetailsSubmit() {
        let challanPostData = setPackingDetails()
        if (packingList?.length > 0) {
            updatePackingDetails(challanPostData,
                (response) => {
                    const data = response.data;
                    if (data.success == true) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "success" });
                        setIsOpen(true);
                        selectPrint()
                        closeAndReset()
                    }
                    else if (data.success == false) {
                        showLoader(false)
                        selectPrint()
                        setAlertStatus({ message: data.message, type: "error" });
                        setIsOpen(true);
                    }
                    else {
                        let errorCode = response.data.error[0].error_code;
                        let errorDescription = response.data.error[0].error_description;
                        showLoader(false)
                        selectPrint()
                        setAlertStatus({ message: errorDescription, type: "error" });
                        setIsOpen(true);
                    }
                }, (error) => {
                    showLoader(false)
                    selectPrint()
                    setAlertStatus({ message: error, type: "error" });
                    setIsOpen(true);
                }
            )
        }
        else {
            selectPrint()
            showLoader(false)
            // toasts("Please Enter Dispatch Details", "Error");
        }
    }

    function closeAndReset() {
        setPackingList([])
        let dateInMilliSeconds = convertDateToEpoch(date);
        if (companyDetailsId?.value != undefined) {
            getScannedProductList(dateInMilliSeconds, companyDetailsId?.value)
        }
    }

    return (
        <PageWrapper title={`AVR Stock List`}>
            <Page>
                <Collapse isOpen={isOpenListCard}>
                    <Card stretch data-tour='list' className='d-print-none'>
                        <CardHeader borderSize={1}>
                            <CardLabel icon='List' iconColor='info'>
                                <CardTitle>AVR Stock List</CardTitle>
                            </CardLabel>
                        </CardHeader>
                        <CardBody>
                            <div className='row g-4'>
                                <div className='col-lg-3'>
                                    <FormGroup
                                        id='date'
                                        label='Date'
                                        isFloating>
                                        <Input
                                            type='date'
                                            placeholder='Date'
                                            onChange={(e: any) => setDate(e.target.value)}
                                            value={date}
                                        />
                                    </FormGroup>
                                </div>
                                <div className='col-lg-5'>
                                    <FormGroup id='placeOfSupply' label='Place of Supply' isFloating>
                                        <SearchableSelect
                                            isFloating
                                            ariaLabel='placeOfSupply'
                                            onChange={(e: any) => { setCompanyDetailsId(e); setDataStatus(false); setProductList([]); setPackingList([]); }}
                                            value={companyDetailsId}
                                            list={companyDetailsData.map((data: any) => ({
                                                value: data.companyDetailsId,
                                                label: data.companyNameAndCityName,
                                            }))}
                                            required
                                        />
                                    </FormGroup>
                                </div>
                                <div className='col-lg-3'>
                                    <Button
                                        color={'primary'}
                                        className='mt-2'
                                        icon='ArrowDownward'
                                        onClick={() => {
                                            setIsPrintShow(false);
                                            viewProductList();
                                        }}>
                                        View
                                    </Button>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>

                <OpenCardComponent isOpenListCard={isOpenListCard} setIsOpenListCard={setIsOpenListCard} isLoader={isLoader} />

                {dataStatus ? <>
                    <Card stretch data-tour='list'>
                        <CardHeader borderSize={1}>
                            <CardLabel icon='List' iconColor='info' className="col-lg-7">
                                <CardTitle tag='div' className='h5'>AVR Stock List</CardTitle>
                            </CardLabel>
                            <CardActions>
                                {productList != '' ?
                                    <>
                                        {isPrintShow ? <>
                                            < Button
                                                color='primary'
                                                isLight
                                                icon='ArrowBack'
                                                onClick={() => {
                                                    setIsPrintShow(false);
                                                }}>
                                                Edit
                                            </Button>
                                            < Button
                                                color='primary'
                                                isLight
                                                icon='Print'
                                                onClick={() => {
                                                    updatePackingDetailsSubmit()
                                                }}>
                                                Print
                                            </Button>
                                        </> :
                                            < Button
                                                color='primary'
                                                isLight
                                                icon='Print'
                                                onClick={() => {
                                                    setIsPrintShow(true);
                                                }}>
                                                Preview
                                            </Button>
                                        }
                                    </> : null
                                }
                            </CardActions>
                        </CardHeader>
                        <CardBody>
                            {productList != '' ?
                                <div className='p-4' id="print-container" ref={componentRef}>
                                    <style dangerouslySetInnerHTML={{
                                        __html: `
                                        @media print {
                                            @page {
                                                margin: 5mm;
                                            }
                                            .print-compact-table {
                                                width: 100% !important;
                                                border-collapse: collapse !important;
                                            }
                                            .print-compact-table th, 
                                            .print-compact-table td {
                                                padding: 3px 3px !important;
                                                font-size: 11px !important;
                                                line-height: 1 !important;
                                                height: auto !important;
                                            }
                                            .print-compact-table h5 {
                                                font-size: 14px !important;
                                                margin: 5px 0 !important;
                                            }
                                            .print-compact-table b {
                                                font-size: 10px !important;
                                            }
                                            #print-container {
                                                overflow: visible !important;
                                                height: auto !important;
                                            }
                                        }
                                    `}} />
                                    {productList.map((item: any, index: number) => (
                                        <div key={index} style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }} className='mb-5'>
                                            <table className="table table-responsive table-bordered border border-dark border-1 print-compact-table small" style={{ fontSize: '12px' }}>
                                                <tbody>
                                                    <tr>
                                                        <td width={'40%'} colSpan={5}>
                                                            <h6 className="text-start text-sm fw-bold ms-2 mt-1">{item.companyName} ( {item.cityName} )
                                                                <br /><span className='text-muted' style={{ fontSize: '10px' }}>Yarn Weight List</span>
                                                            </h6>
                                                        </td>
                                                        <td className="text-start" width={'30%'} colSpan={4}>
                                                            <div className="ms-5 mt-3"><b>Date : </b>{item.updatedDateForView}</div>
                                                        </td>
                                                        <td className="text-center mt-3" width={'20%'} colSpan={3}><div className="ms-5 mt-3"><b>Truck No : </b>{item.truckNo}</div></td>
                                                    </tr>

                                                    <tr>
                                                        <td style={{ lineHeight: '0.1' }} width={'50%'} colSpan={12}>
                                                            {/* <div className="grid grid-cols-3 gap-2 mt-2"> */}
                                                            <div className="text-center font-semibold border-b border-black py-1 fw-bold mt-1" style={{ fontSize: '11px' }}>
                                                                {item.countNo} [Lot No : &nbsp;{item.lotNo}]
                                                            </div>
                                                            {/* </div> */}
                                                        </td>
                                                    </tr>
                                                    <tr className='text-center'>
                                                        <td className='' width="5%">S.No</td>
                                                        <td className='border border-dark' width="10%">Bag <br /> Number</td>
                                                        <td className='border border-dark' width="8%">Excise <br /> Number</td>
                                                        <td className='border border-dark' width="10%">Gross <br /> Weight</td>
                                                        <td className='border border-dark' width="8%">Tare</td>
                                                        <td className='border border-dark' width="10%">Net <br /> Weight</td>

                                                        <td className='' width="6%">S.No</td>
                                                        <td className='border border-dark' width="10%">Bag <br /> Number</td>
                                                        <td className='border border-dark' width="8%">Excise <br /> Number</td>
                                                        <td className='border border-dark' width="10%">Gross <br /> Weight</td>
                                                        <td className='border border-dark' width="8%">Tare</td>
                                                        <td className='' width="10%">Net <br /> Weight</td>
                                                    </tr>

                                                    {item.leftRows.map((leftRow: any, i: any) => {
                                                        const rightRow = item.rightRows[i];  // match right row by index

                                                        return (
                                                            <tr className='text-center' key={i}>
                                                                {/* LEFT SIDE */}
                                                                <td className="p-1 ">{leftRow.sno}</td>
                                                                <td className="border border-dark p-1">{leftRow.bagNo}</td>
                                                                <td className="border border-dark p-1">{leftRow.exciseNo}</td>
                                                                <td className="border border-dark p-1">{leftRow.grossWeight}</td>
                                                                <td className="border border-dark p-1">{leftRow.tareWeight}</td>
                                                                <td className="border border-dark p-1">{leftRow.netWeight}</td>

                                                                {/* RIGHT SIDE */}
                                                                {rightRow ? (
                                                                    <>
                                                                        <td className="p-1">{rightRow.sno}</td>
                                                                        <td className="border border-dark p-1">{rightRow.bagNo}</td>
                                                                        <td className="border border-dark p-1">{rightRow.exciseNo}</td>
                                                                        <td className="border border-dark p-1">{rightRow.grossWeight}</td>
                                                                        <td className="border border-dark p-1">{rightRow.tareWeight}</td>
                                                                        <td className="p-1">{rightRow.netWeight}</td>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <td></td><td></td><td></td><td></td><td></td><td></td>
                                                                    </>
                                                                )}
                                                            </tr>

                                                        );
                                                    })}
                                                    <tr className='text-center'>
                                                        <td className="p-1 fw-bold" colSpan={3}>Total</td>
                                                        <td className="border border-dark p-1">{item?.leftTotals?.gross.toFixed(2)}</td>
                                                        <td className="border border-dark p-1">{item?.leftTotals?.tare.toFixed(2)}</td>
                                                        <td className="border border-dark p-1">{item?.leftTotals?.net.toFixed(2)}</td>
                                                        <td className="border border-dark p-1 fw-bold" colSpan={3}>Total</td>
                                                        <td className="border border-dark p-1">{item?.rightTotals?.gross.toFixed(2)}</td>
                                                        <td className="border border-dark p-1">{item?.rightTotals?.tare.toFixed(2)}</td>
                                                        <td className="p-1">{item?.rightTotals?.net.toFixed(2)}</td>
                                                    </tr>

                                                    <tr>
                                                        <td className="text-center fw-bold">S.No</td>
                                                        <td colSpan={2} className="fw-bold">Count No</td>
                                                        <td className="text-center fw-bold">Bags</td>
                                                        <td className="text-center fw-bold">Gross Wt.</td>
                                                        <td className="text-center fw-bold">Tare</td>
                                                        <td className="text-center fw-bold">Net Wt.</td>
                                                        <td className="text-center border border-dark fw-bold" colSpan={4}>Packing / Date</td>
                                                        <td className="text-center fw-bold fw-bold">Count</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-center" rowSpan={item.packingList.length + 1}>1</td>
                                                        <td rowSpan={item.packingList.length + 1} colSpan={2}>{item.countNo}</td>
                                                        <td className="text-center" rowSpan={item.packingList.length + 1}>{item.packingList?.length}</td>
                                                        <td className="text-center" rowSpan={item.packingList.length + 1}>{item.totalGrossWeight.toFixed(2)}</td>
                                                        <td className="text-center" rowSpan={item.packingList.length + 1}>{item.totalTareWeight.toFixed(2)}</td>
                                                        <td className="text-center" rowSpan={item.packingList.length + 1}>{item.totalNetWeight.toFixed(2)}</td>
                                                    </tr>

                                                    {!isPrintShow ? <>
                                                        {item.packingList.map((i: any, index: any) => (
                                                            <tr>
                                                                <td className="text-center border border-dark" colSpan={2}>
                                                                    <FormGroup id='value1' label=''>
                                                                        <Input
                                                                            onChange={(e: any) => onValueChange(item, e.target.value, i.packingDate, i.packingCount, index)}
                                                                            value={i.packingDescription}
                                                                            placeholder="Enter..."
                                                                            type='text'
                                                                        />
                                                                    </FormGroup>
                                                                </td>
                                                                <td className="text-center border border-dark" colSpan={2}>
                                                                    <FormGroup id='date1' label=''>
                                                                        <Input
                                                                            onChange={(e: any) => onValueChange(item, i.packingDescription, e.target.value, i.packingCount, index)}
                                                                            value={i.packingDate}
                                                                            placeholder="Enter..."
                                                                            type='date'
                                                                        />
                                                                    </FormGroup>
                                                                </td>
                                                                <td className="text-center">
                                                                    <FormGroup id='count1' label=''>
                                                                        <Input
                                                                            onChange={(e: any) => onValueChange(item, i.packingDescription, i.packingDate, e.target.value, index)}
                                                                            value={i.packingCount}
                                                                            placeholder="Enter..."
                                                                            type='text'
                                                                            onKeyDown={(e: any) => onlyAllowNumber(e)}
                                                                        />
                                                                    </FormGroup>
                                                                </td>
                                                            </tr>
                                                        ))} </> :
                                                        <>
                                                            {item.packingList.map((i: any, index: any) => (
                                                                <tr>
                                                                    <td className="text-center border border-dark" colSpan={2}>{i?.packingDescription}</td>
                                                                    <td className="text-center border border-dark" colSpan={2}>{i?.packingDate != '' ? dayjs(i?.packingDate).format('DD-MM-YYYY') : ''}</td>
                                                                    <td className="text-center">{i.packingCount}</td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                    }
                                                    <tr>
                                                        <td colSpan={7}></td>
                                                        <td className="text-center border border-dark" colSpan={4}>Avg / Count</td>
                                                        <td className="text-center">{item?.totalPackingCount}</td>
                                                    </tr>
                                                </tbody>
                                            </table>


                                            <table className="table border-0 w-100 mt-2 small">
                                                <tbody>
                                                    <tr>
                                                        <td width={'20%'} className="border-0"><span className='ms-2'>Incharge</span></td>
                                                        <td width={'20%'} className="border-0">Che By</td>
                                                        <td width={'20%'} className="border-0">Fm</td>
                                                        <td width={'20%'} className="border-0">Gm</td>
                                                        <td width={'20%'} className="border-0"></td>
                                                        <td width={'20%'} className="border-0">
                                                            {!isPrintShow ?
                                                                <Button
                                                                    className='d-print-none'
                                                                    color='primary'
                                                                    onClick={() => add(item)}
                                                                    isDisable={!item.packingList.every((p: any) => p.packingDescription && p.packingDate && p.packingCount)}
                                                                >
                                                                    Add
                                                                </Button> : null
                                                            }
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    ))}
                                </div> : <div className="text-center fw-bold text-danger">{noDataMsg}</div>
                            }

                        </CardBody>
                    </Card></> : null
                }
            </Page>
        </PageWrapper >
    )
}

export default AvrDispatchList